import React from "react";
import Layout from "../../HOC/Layput/Layout";
import "./Error.css";
import ErrorLogo from "../../assets/Images/Error.svg";
const Error = props => {
  document.title = "VK Global Publications |  Error"

  return (
    <div className = "confirmation">
      <img
                className="text-center"
                width="100"
                height="100"
                src={ErrorLogo}
                alt="error"
              />
  <h6 className ="text-center"> 404 Not Found</h6>
       
    </div>
  );
};

export default Layout(Error, "Error");
